import {Tooltip} from "@mantine/core";
import {DibJsonNode} from "../../types";
import LegacyCommentIcon from "../../../../assets/comment-text.svg?react";
import classes from "./xFootnote.module.css";

type Props = {
    node: DibJsonNode;
};

export const XFootnote = ({node}: Props) => {
    const attrs = node.element?.attributes;
    const dataTitle = attrs?.["data-title"] ?? attrs?.title ?? "";
    const id = attrs?.id;

    return (
        <Tooltip label={dataTitle} position="top" withArrow multiline maw={300}>
            <span id={id} className={classes.xFootnote}>
                <LegacyCommentIcon className={classes.icon} />
            </span>
        </Tooltip>
    );
};
